export default __webpack_public_path__ + "static/media/logo-dark.e255621b.svg";